/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Page_Meta_TitleInputs */

const en_serve_page_meta_title = /** @type {(inputs: Serve_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build on your own computer — Bystep`)
};

const id_serve_page_meta_title = /** @type {(inputs: Serve_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bangun di komputermu sendiri — Bystep`)
};

/**
* | output |
* | --- |
* | "Build on your own computer — Bystep" |
*
* @param {Serve_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_page_meta_title = /** @type {((inputs?: Serve_Page_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Page_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_page_meta_title(inputs)
	return en_serve_page_meta_title(inputs)
});